import { render, staticRenderFns } from "./CardMetodoPagamento.vue?vue&type=template&id=72d54f60"
import script from "./CardMetodoPagamento.vue?vue&type=script&lang=js"
export * from "./CardMetodoPagamento.vue?vue&type=script&lang=js"
import style0 from "./CardMetodoPagamento.vue?vue&type=style&index=0&id=72d54f60&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports